export default "__VITE_ASSET__03819e2d__"